<template>
    <div>

                      <div class="row justify-content-center">
                      <div class=" col-sm-12">
                         <div class="card">
                          <div class="card-body">
                        <apexchart type=bar height="700"  :options="options" :series="series2" v-if="show==true" />
                          </div>
                         </div>
                      </div>

                      </div>
    </div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
                show:false,
             options: {
                title: {
                 text: 'Airtime Chart',
                 align: 'left'
                 },
                    chart: {
                        id: 'vuechart-example'
                    },
                    xaxis: {
                        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug","Sept","Oct","Nov","Dec"]
                    }
                },
                series2: [
                    {
                    name: 'Airtime Purchased',
                    data:[],
                     },
                     {
                    name: 'Airtime Converted',
                    data:[],
                     }
                      ],
            }
        },
        created(){
              this.dashboard();
        },
        methods: {

            dashboard(){
                let uri =`/api/auth/graph`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.series2[0].data=response.data.purchased;
                    this.series2[1].data=response.data.converted;
                    this.show=true;
                }).catch(error => {
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },


            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            filerDate(date){
                return moment(String(date)).format('MM/DD/YYYY HH:mm')
            }

        },
    }

</script>
